export default __webpack_public_path__ + "static/media/truck_icon_white.38dc4b6e.svg";